import React from "react";
import useCompareTab from "./useCompareTab";
import { TabHeading } from "../../../Global/TabHeading";
import VersionOne from "./VersionOne";
import { Button } from "@wac-ui-dashboard/wac_component_library";
import Style from "./compareTab.module.scss";
import DetailsTable from "./DetailsTable";
import VersionTwo from "./VersionTwo";

const CompareTab = ({ reportRef, activeCard, statusData, handleConfirm }) => {
  const {
    data,
    activeId,
    showVersionTwoTable,
    handleClick,
    handleAdd,
    excelCopyPermission,
  } = useCompareTab({ reportRef });

  return (
    <>
      {showVersionTwoTable ? (
        <div className="pro-p-5">
          <DetailsTable />
        </div>
      ) : (
        <div className={`pro-w-100 ${Style.compare_wrap}`}>
          <TabHeading
            data={data}
            uniqueId={"id"}
            activeId={activeId}
            handleClick={handleClick}
          />

          <div
            className={`pro-ms-4 pro-d-flex pro-flex-column ${Style.tabs_wrap}`}
          >
            {activeId === 1 ? <VersionOne statusData={statusData}/> : <VersionTwo statusData={statusData}/>}
          </div>
          
          <div
            className={`col-12 pro-d-flex pro-justify-end pro-py-3 pro-px-5 pro-gap-3 ${Style.footer_btn_wrap} `}
          >
            {activeId === 1 && (
              <>
                {activeId === 1 && excelCopyPermission &&(
                  <Button
                    className={"pro-btn-outline  "}
                    type="button"
                    onClick={handleAdd}
                  >
                    Create a copy
                  </Button>
                )}
              </>
            )}
          </div>
          {/* )} */}
        </div>
      )}
    </>
  );
};

export default CompareTab;
